import React from 'react'

import { ICircularProgressProps } from './models'

import styles from './CircularProgress.module.scss'

export const CircularProgress = ({
  percent = 0,
  radius,
  isShowCompletedIcon,
}: ICircularProgressProps) => {
  const fontSize = radius / 1.5

  if (isShowCompletedIcon) {
    return (
      <div className={styles.completedCircle} style={{ width: radius * 2, height: radius * 2 }}>
        <i style={{ fontSize }} className={'kbase kbase-check'} />
      </div>
    )
  }

  const circumference = 2 * Math.PI * radius
  const offset = circumference - (percent / 100) * circumference

  const isFull = percent === 100

  return (
    <div>
      <svg width={radius * 2} height={radius * 2} viewBox={`0 0 ${radius * 2} ${radius * 2}`}>
        <circle
          cx={radius}
          cy={radius}
          r={radius - 2}
          fill={isFull ? '#4294d0' : '#e6e6e6'}
          stroke="#ddd"
          strokeWidth="3"
        />
        <circle
          cx={radius}
          cy={radius}
          r={radius - 2}
          fill="transparent"
          stroke="#4294d0"
          strokeWidth="3"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
        <text
          x="50%"
          y="52%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={fontSize}
          fill={isFull ? '#fff' : '#333'}
        >
          {percent}%
        </text>
      </svg>
    </div>
  )
}
